import {useCallback, useMemo} from 'react';
// eslint-disable-next-line no-restricted-imports -- Single sanctioned reader for React Router search state (see ESLint rule for useSearchParams)
import {useSearchParams} from 'react-router-dom';

import {composePath, type OptionsType} from '../utils/composePath';

/**
 * Returns `composePath` that merges against the **router’s** current search params instead of
 * `window.location`, keeping links in sync after `setSearchParams` / `useQueryState` updates.
 */
export function useComposePath() {
  const [searchParams] = useSearchParams();
  const currentQueryParams = useMemo(
    () => Object.fromEntries(searchParams.entries()),
    [searchParams]
  );

  return useCallback(
    <Path extends string>(path: Path, options?: OptionsType<Path>) =>
      composePath(path, options, currentQueryParams),
    [currentQueryParams]
  );
}
